import { Skeleton as ShadcnSkeleton } from '~/components/ui/skeleton';
import { cn } from '~/lib/utils';

export interface SkeletonProps {
  className?: string;
}

/**
 * The single skeleton placeholder for the app (muted moving shimmer).
 *
 * Use for first-load placeholders where the destination layout is KNOWN
 * (table rows, cards, chart panels, detail views) — content replaces the
 * skeleton 1:1. Do NOT use it in place of a spinner; and never show
 * skeletons again on refetch/pagination — retain the old data instead
 * (see the Loading States rules in portal/AGENTS.md).
 */
export default function Skeleton({ className }: SkeletonProps) {
  return <ShadcnSkeleton aria-hidden className={cn('rounded', className)} />;
}
